export const AVG_WIN_LOSS_CURRENCY = {
  prefix: "$",
  value1: 214.6357244571021716,
  label1: "Avg Win",
  value2: -194.506446529013884,
  label2: "Avg Loss",
  suffix: "",
  decimals: 0,
};
